import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import ContentDashboard from "../Components/Dashboard/ContentDashboard";

function Dashboard() {
    const { user } = useAuth();

    if (!user) {
        return <Navigate to="/"/>;
    }
    return(
        <>
            <ContentDashboard/>
        </>
    );
}
export default Dashboard;